/**
 * The run detail as an overlay (below `lg`).
 *
 * A WRAPPER, NOT A SECOND IMPLEMENTATION. Since SYNC-3b the fields, the counters
 * and the error copy all live in `BexioSyncRunDetailContent`, which the desktop
 * panel renders too. This file contributes the sheet: Escape, the overlay click,
 * the focus trap and the focus return come from the shared `BexioDetailDrawer`
 * (Radix Dialog underneath) rather than being re-implemented per page.
 *
 * The sheet title is the generic "Laufdetails" because the content's own header
 * already names the scope, carries the status pill and shows the run id — the
 * same header the panel shows. Repeating the scope in the sheet chrome would be
 * the one piece of detail markup existing twice.
 */
import React from "react";

import BexioDetailDrawer from "../../../components/admin/bexio/workspace/BexioDetailDrawer";
import BexioSyncRunDetailContent from "./BexioSyncRunDetailContent";

export default function BexioSyncRunDetailDrawer({ open, onOpenChange, run }) {
  return (
    <BexioDetailDrawer open={open} onOpenChange={onOpenChange} title="Laufdetails">
      <BexioSyncRunDetailContent run={run} />
    </BexioDetailDrawer>
  );
}
